import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { deleteNoteTemplate, NoteTemplate } from '../../../../api/note-templates';
import { toast } from 'react-toastify';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onDeleted: () => void;
    templateToDelete: NoteTemplate | null;
};

const DeleteNoteTemplateModal: React.FC<Props> = ({ isOpen, onClose, onDeleted, templateToDelete }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleteClick = async () => {
        if (!templateToDelete) return;

        setLoading(true);
        try {
            await deleteNoteTemplate(templateToDelete.id);
            toast.success('Note template deleted successfully');
            onDeleted();
            onClose();
        } catch (error: any) {
            console.error('Error deleting note template:', error);
            toast.error(error.message || 'Failed to delete template');
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} width={'500px'}>
            <div className='delete-block-container'>
                <div className='modal-header'>
                    <div className='title'>Are you sure you want to delete note template?</div>
                    <div className='sub-title'>All data will be permanently removed.</div>
                </div>

                <div className='submit-btn-wrapper'>
                    <Button
                        text='Cancel'
                        onClick={onClose}
                        backgroundColor={'#ffffff'}
                        color={'#2D334E'}
                        width={'100%'}
                    />
                    <Button
                        text='Delete'
                        onClick={onDeleteClick}
                        isLoading={loading}
                        width={'100%'}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DeleteNoteTemplateModal;
